import React from 'react';
import trans from '../../translations.json';

class DownloadMenuTranslate extends React.Component {
  componentDidMount() {
    window.addEventListener('load', this.init);
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.init);
  }

  init = () => {
    setTimeout(() => {
      if (this.props.lang === 'en') return;

      var allDownloadMenuItems = document.getElementsByClassName(
        'apexcharts-menu-item',
      );
      allDownloadMenuItems.forEach((elem) => {
        var translated = elem.innerHTML.replace(
          'Download',
          trans.overview.download.fr,
        );
        elem.innerHTML = translated;
        elem.title = translated;
      });
    }, 2000);
  };
  render() {
    return '';
  }
}
export default DownloadMenuTranslate;
